import { saveSandboxContact } from '@/modules/api/codegen';
import { omitUndefined } from '@/services/utilities/object';

import { getUtmParams } from './utm';

export async function createSandboxContacts(email: string) {
    const utmParams = getUtmParams();

    const body = omitUndefined({
        email,
        utmParams,
    });

    await saveSandboxContact(body);
}
